import React, { useState } from "react";
import styles from "./SelectSnapshotModal.module.scss";
import { IModalInstance } from "@whatslly/ui-components/modals/ModalProvider";
import { BaseModal, ModalHeader } from "@whatslly/ui-components/modals";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { SidecarSnapshotInfo } from "@whatslly/types/sidecars-server/Sidecar";
import dayjs from "dayjs";
import { Tooltip } from "@whatslly/ui-components/Tooltip";
import classnames from "classnames";

const Snapshot: React.FC<{ snapshot: SidecarSnapshotInfo; onSelect: (snapshot: SidecarSnapshotInfo) => void; selected: boolean }> = ({
  snapshot,
  onSelect,
  selected,
}) => {
  return (
    <div className={classnames(styles.snapshot, { [styles.selected]: selected })} onClick={() => onSelect(snapshot)}>
      <div className={styles.snapshotName}>{snapshot.name}</div>
      <div className={styles.snapshotMetadata}>
        <Tooltip value={dayjs(snapshot.createdAt).format("DD/MM/YYYY HH:mm")}>
          <span>Created {dayjs(snapshot.createdAt).fromNow()}</span>
        </Tooltip>
        <Tooltip value={dayjs(snapshot.expiresAt).format("DD/MM/YYYY HH:mm")}>
          <span>Expires {dayjs(snapshot.expiresAt).fromNow()}</span>
        </Tooltip>
        <span>Size: {snapshot.restoreSize}</span>
      </div>
    </div>
  );
};

export const SelectSnapshotModal: React.FC<IModalInstance & { snapshots: SidecarSnapshotInfo[] }> = ({ closeModal, snapshots }) => {
  const [selectedSnapshot, setSelectedSnapshot] = useState<SidecarSnapshotInfo | undefined>();

  const handleSelectSnapshot = (snapshot: SidecarSnapshotInfo) => {
    if (selectedSnapshot?.name === snapshot.name) {
      setSelectedSnapshot(undefined);
      return;
    }
    setSelectedSnapshot(snapshot);
  };

  return (
    <BaseModal
      header={
        <ModalHeader closeModal={closeModal}>
          <div className={styles.headerTitle}>
            <h2>Select Snapshot</h2>
            <p>Select a snapshot to apply to the sidecar</p>
          </div>
        </ModalHeader>
      }
      closeOnClickOutside={false}
      closeOnEscape={true}
      closeModal={closeModal}
      className={styles.modal}
      bodyClassName={styles.body}
    >
      <hr />
      <div className={styles.snapshots}>
        {snapshots.map((s) => (
          <Snapshot key={s.name} snapshot={s} onSelect={handleSelectSnapshot} selected={selectedSnapshot?.name === s.name} />
        ))}
      </div>
      <ModalButtons
        onSubmit={() => closeModal(selectedSnapshot)}
        onCancel={closeModal}
        submitText="Apply Snapshot"
        cancelText="Cancel"
        testId="submit-snapshot-modal"
        isSubmitDisabled={!selectedSnapshot}
      />
    </BaseModal>
  );
};
